import { shallow } from "zustand/shallow";
import { createWithEqualityFn as create } from "zustand/traditional";
export interface LenderApplicationDetailsStore {
  currentlyUpdatingLenderResponseId: number | null;
  setCurrentlyUpdatingLenderResponseId: (
    currentlyUpdatingLenderResponseId: number | null,
  ) => void;
}

export const useLenderApplicationDetailsStore =
  create<LenderApplicationDetailsStore>()((set) => {
    return {
      currentlyUpdatingLenderResponseId: null,
      setCurrentlyUpdatingLenderResponseId: (
        currentlyUpdatingLenderResponseId: number | null,
      ) => set({ currentlyUpdatingLenderResponseId }),
    };
  }, shallow);
